(() => {
  if (window.__ivelloraLoadMoreReady) return;
  window.__ivelloraLoadMoreReady = true;

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-ivellora-load-more]');
    if (!link) return;

    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    const label = link.querySelector('span');
    if (label) label.textContent = 'Loading…';

    try {
      const response = await fetch(link.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);
      const html = await response.text();
      const page = new DOMParser().parseFromString(html, 'text/html');
      const currentList = link.closest('results-list');
      const currentGrid = currentList?.querySelector('[data-testid="product-grid"]');
      const nextGrid = page.querySelector('#ResultsList [data-testid="product-grid"]');
      const nextWrap = page.querySelector('#ResultsList [data-ivellora-load-more-wrap]');
      const currentWrap = link.closest('[data-ivellora-load-more-wrap]');
      if (!currentGrid || !nextGrid || !nextWrap || !currentWrap) throw new Error('Load More markup not found');

      const cards = Array.from(nextGrid.children);
      currentGrid.append(...cards);
      currentWrap.replaceWith(nextWrap);
      history.replaceState({ ivelloraCollectionPage: link.href }, '', link.href);
      sessionStorage.setItem(`ivellora-collection:${location.pathname}`, link.href);
    } catch (error) {
      window.location.assign(link.href);
    }
  });
})();
